
<div id="settingsConfig" class="settings-configuration-page">
  <div class="login-sec">
      <i class="icon-back backIcon" (click)="navigateToLogin()"></i>
      <label class="l-text">{{ settingDetails?.globalSettings }}</label>
  </div>
  <div class="settings-form-container">
    <app-dynamic-form [config]="config" #form="dynamicForm" (submit)="submit($event)">
    </app-dynamic-form>
  </div>
  <app-toast-message [show]='toastShow' [message]="toastMessage" (ToastDismiss)='toastDismissed($event)' (AutoDismiss)='toastAutoDismiss($event)'></app-toast-message>
</div>

